/**
 * Шапка с логотипом.
 *
 * Стоит на всех вкладках: это марка приложения, а не заголовок экрана,
 * и её исчезновение при переходе читалось бы как переход в другое место.
 */
import { Logo } from './Logo';
import styles from './Header.module.css';

export function Header() {
  return (
    <header className={styles.header}>
      <Logo />
    </header>
  );
}
